export class FoodCategory {
  menuCategoryId?: number;
  menuCategoryTypeId?: number;
  menuCategoryName?: string;
  menuCategoryNameEN?: string;
  menuCategoryStatus?: string;

  constructor(Obj: any = {}) {
    this.menuCategoryId = Obj.menuCategoryId;
    this.menuCategoryTypeId = Obj.menuCategoryTypeId;
    this.menuCategoryName = Obj.menuCategoryName;
    this.menuCategoryNameEN = Obj.menuCategoryNameEN;
    this.menuCategoryStatus = Obj.menuCategoryStatus;
  }
}
